var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGnbIco05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 4C19.1046 4 20 4.89543 20 6V15C20 16.1046 19.1046 17 18 17H13V18.5H15.25C15.6642 18.5 16 18.8358 16 19.25C16 19.6642 15.6642 20 15.25 20H8.75C8.33579 20 8 19.6642 8 19.25C8 18.8358 8.33579 18.5 8.75 18.5H11V17H6C4.89543 17 4 16.1046 4 15V6C4 4.89543 4.89543 4 6 4H18ZM7 10C6.44772 10 6 10.4477 6 11C6 11.5523 6.44772 12 7 12H16C16.5523 12 17 11.5523 17 11C17 10.4477 16.5523 10 16 10H7ZM7 7C6.44772 7 6 7.44772 6 8C6 8.55228 6.44772 9 7 9H11C11.5523 9 12 8.55228 12 8C12 7.44772 11.5523 7 11 7H7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnbIco05);
export default __webpack_public_path__ + "static/media/Gnb_ico_05.b6931b7276b32e70f455eac12b0e5301.svg";
export { ForwardRef as ReactComponent };